import { render } from "./TrialBanner.vue?vue&type=template&id=521ef379&scoped=true"
import script from "./TrialBanner.vue?vue&type=script&lang=js"
export * from "./TrialBanner.vue?vue&type=script&lang=js"

import "./TrialBanner.vue?vue&type=style&index=0&id=521ef379&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521ef379"]])

export default __exports__